export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full min-h-[620px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/70 via-background-50/90 to-background-50 z-0"></div>
      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-accent-500/15 text-accent-400 border border-accent-500/25 mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>全网热播 · 高清秒开
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-50 leading-tight mb-4">
              香蕉影视<span className="text-primary-400"> · </span>高清免费在线观看平台
            </h1>
            <p className="text-lg md:text-xl text-primary-400 font-medium mb-6">
              追剧必备，精彩不间断
            </p>
            <p className="text-foreground-300 leading-relaxed text-sm md:text-base max-w-[580px] mx-auto lg:mx-0 mb-8">
              香蕉影视汇聚海量高清影视资源，涵盖最新热播电影、电视剧、综艺、动漫等全品类内容。
              采用高速CDN加速技术，实现不缓冲秒开体验，画质高清流畅不卡顿。
              每日持续更新30+部热门内容，无论最新院线大片还是经典剧集合集，随时随地免费在线观看，打造你的专属追剧天地。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-foreground-50">10万+</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-foreground-800/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-400">秒开</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">不缓冲不卡顿</div>
              </div>
              <div className="w-px h-10 bg-foreground-800/50 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-accent-400">30+</div>
                <div className="text-xs md:text-sm text-foreground-400 mt-1">每日更新</div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#ranking" className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-bold rounded-lg text-base transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-play-circle-line text-lg"></i>立即观影
              </a>
              <a href="#about" className="inline-flex items-center gap-2 px-8 py-3 bg-background-200 hover:bg-background-300 text-foreground-100 font-medium rounded-lg text-base transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-400/30">
                <i className="ri-information-line text-lg"></i>了解更多
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-xl overflow-hidden bg-background-200/80 border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20entertainment%20collage%20with%20warm%20amber%20and%20gold%20lighting%2C%20film%20strips%20and%20vintage%20cinema%20elements%20floating%20in%20dark%20space%2C%20dramatic%20spotlight%20effects%2C%20movie%20poster%20silhouettes%2C%20elegant%20theatrical%20composition%2C%20rich%20contrast%20with%20deep%20shadows%20and%20warm%20highlights%2C%20cinematic%20atmosphere&width=800&height=600&seq=hero-main-visual-001&orientation=landscape"
                alt="香蕉影视高清观影体验"
                className="w-full h-auto object-cover"
                width="800"
                height="600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}